import { Factory, PackageSearch } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const productionItems = [
  {
    path: '/production/order-monitoring',
    label: 'WH Monitoring',
    icon: PackageSearch,
    description: 'Śledź zamówienia i dostawy WH'
  },
  {
    path: '/production/schuco-monitoring',
    label: 'Schüco Monitoring',
    icon: PackageSearch,
    description: 'Śledź zamówienia i dostawy Schüco'
  },
  {
    path: '/production/glass-monitoring',
    label: 'Szklenie Monitoring',
    icon: PackageSearch,
    description: 'Śledź zamówienia i dostawy szklenia PressGlass i AGC'
  },
  {
    path: '/production/blinds',
    label: 'Rolety',
    icon: PackageSearch,
    description: 'Predykcja czasu dostaw materiałów roletowych'
  }
];

const Production = () => {
  const {
    canAccessProductionMonitor,
    canAccessProductionSchucoMonitor,
    canAccessProductionBlinds,
    canAccessProductionGlassMonitor,
  } = useAuth();

  // Filter production items based on permissions
  const filteredItems = productionItems.filter(item => {
    if (item.path === '/production/order-monitoring') return canAccessProductionMonitor();
    if (item.path === '/production/schuco-monitoring') return canAccessProductionSchucoMonitor();
    if (item.path === '/production/blinds') return canAccessProductionBlinds();
    if (item.path === '/production/glass-monitoring') return canAccessProductionGlassMonitor();
    return true;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="module-page-title"><Factory aria-hidden="true" /> Produkcja</h2>
        <p>Usługi i zasoby dla działu produkcji</p>
      </div>
      
      <div className="page-content">
        <div className="tiles-grid">
          {filteredItems.map((item) => {
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className="tile-card module-tile">
              <span className="tile-icon module-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
              <h3 className="tile-title">{item.label}</h3>
              <p className="tile-description">{item.description}</p>
            </Link>;
          })}
        </div>
      </div>
    </div>
  );
};

export { productionItems };
export default Production;
